/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import cx from 'classnames';
import React, { useState } from 'react';

import s from './input.module.css';

import type { InputProps } from './index';

export interface InputIconProps extends InputProps {
    icon: React.ReactNode;
}

export const InputIcon = React.forwardRef<HTMLInputElement, InputIconProps>(
    (
        {
            id,
            disabled,
            name,
            label,
            icon,
            errorText,
            error = false,
            className,
            wrapperClassName,
            onClick,
            ...props
        },
        ref
    ): JSX.Element => {
        const [focus, setFocus] = useState(false);
        return (
            <div className={cx(s.container, wrapperClassName)}>
                {label && (
                    <label htmlFor={id || name} className={s.label}>
                        {label}
                    </label>
                )}
                <div
                    className={cx(s.inputIcon, className, {
                        [s.disabled]: disabled,
                        [s.error]: error,
                        [s.focus]: focus,
                    })}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                    onClick={onClick}
                >
                    <input id={id || name} name={name} disabled={disabled} ref={ref} {...props} />
                    <div className={s.iconContainer}>{icon}</div>
                </div>
                {error && errorText && <p className={cx(s.errorText, 'annotation')}>{errorText}</p>}
            </div>
        );
    }
);

export default InputIcon;
